<template>
  <application-layout>
    <v-main>
      <v-container>
        <v-form
          ref="globalSettingsForm"
          @submit.prevent="submitGlobalSettingsForm"
        >
          <h1>Manage Global Settings</h1>
          <v-tabs show-arrows>
              <v-tab
                data-testid="global-setting-system-default-tab"
                class="global-setting-system-default-tab"
              >
                System Defaults
              </v-tab>
              <v-tab
                data-testid="global-setting-custom-code-tab"
                class="global-setting-custom-code-tab"
              >
                Custom Code
              </v-tab>

              <v-tab-item :style="$vuetify.theme.dark ? darkThemeBgColor : ''">
                <h2 class="mt-4 mb-2">System Defaults</h2>

                <div v-if="globalSettings.length">
                  <v-row>
                    <v-col cols="4">
                      <app-input
                        data-testid="global-setting-markup-pct-input"
                        class="global-setting-markup-pct-input"
                        :type="'number'"
                        :label="findSetting('globalSettings', 'global_markup_percent').label"
                        v-model="findSetting('globalSettings', 'global_markup_percent').value"
                        :error-messages="findError('global_markup_percent')"
                        :error="!!findError('global_markup_percent')"
                      />
                    </v-col>
                    <v-col cols="4">
                      <app-input
                        data-testid="global-setting-global-search-input"
                        class="global-setting-global-search-input"
                        :type="'number'"
                        :label="findSetting('globalSettings', 'global_search_radius').label"
                        v-model="findSetting('globalSettings', 'global_search_radius').value"
                        :error-messages="findError('global_search_radius')"
                        :error="!!findError('global_search_radius')"
                      />
                    </v-col>
                    <v-col cols="4">
                      <app-input
                        data-testid="global-setting-global-phone-input"
                        class="global-setting-global-phone-input"
                        :type="'text'"
                        :label="findSetting('globalSettings', 'global_phone_number').label"
                        v-model="findSetting('globalSettings', 'global_phone_number').value"
                        :error-messages="findError('global_phone_number')"
                        :error="!!findError('global_phone_number')"
                      />
                    </v-col>
                    <v-col cols="4">
                      <app-input
                        data-testid="global-setting-reservation-max-input"
                        class="global-setting-reservation-max-input"
                        :type="'number'"
                        :label="findSetting('globalSettings', 'global_reservation_lead_max').label"
                        v-model="findSetting('globalSettings', 'global_reservation_lead_max').value"
                        :error-messages="findError('global_reservation_lead_max')"
                        :error="!!findError('global_reservation_lead_max')"
                      />
                    </v-col>
                    <v-col cols="4">
                      <app-input
                        data-testid="global-setting-office-address-input"
                        class="global-setting-office-address-input"
                        :type="'text'"
                        :label="findSetting('globalSettings', 'global_corporate_office_address').label"
                        v-model="findSetting('globalSettings', 'global_corporate_office_address').value"
                        :error-messages="findError('global_corporate_office_address')"
                        :error="!!findError('global_corporate_office_address')"
                      />
                    </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <h3>Distribution Emails</h3>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <app-input
                      data-testid="global-bre-price-email-input"
                      class="global-bre-price-email-input"
                      :type="'email'"
                      :label="findSetting('globalSettings', 'global_bre_price_suggestions_email').label"
                      v-model="findSetting('globalSettings', 'global_bre_price_suggestions_email').value"
                      :error-messages="findError('global_bre_price_suggestions_email')"
                      :error="!!findError('global_bre_price_suggestions_email')"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <h3>Past Due Payments</h3>
                    <h4 class="mt-4 font-weight-regular">
                      <span class="font-weight-bold">Note:</span> these settings only control Storage360. You will need
                      to ensure these settings are also set in your property management system.
                    </h4>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <app-input
                      data-testid="global-cc-sales-past-due-input"
                      class="global-cc-sales-past-due-input"
                      :type="'number'"
                      :label="findSetting('globalSettings', 'global_cc_sales_past_due').label"
                      v-model="findSetting('globalSettings', 'global_cc_sales_past_due').value"
                      :error-messages="findError('global_cc_sales_past_due')"
                      :error="!!findError('global_cc_sales_past_due')"
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-input
                      data-testid="global-cc-ar-past-due-input"
                      class="global-cc-ar-past-due-input"
                      :type="'number'"
                      :label="findSetting('globalSettings', 'global_cc_ar_past_due').label"
                      v-model="findSetting('globalSettings', 'global_cc_ar_past_due').value"
                      :error-messages="findError('global_cc_ar_past_due')"
                      :error="!!findError('global_cc_ar_past_due')"
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-input
                      data-testid="global-website-past-due-input"
                      class="global-website-past-due-input"
                      :type="'number'"
                      :label="findSetting('globalSettings', 'global_website_past_due').label"
                      v-model="findSetting('globalSettings', 'global_website_past_due').value"
                      :error-messages="findError('global_website_past_due')"
                      :error="!!findError('global_website_past_due')"
                    />
                  </v-col>
                </v-row>

                  <v-row>
                    <v-col>
                      <h3>Error Messages</h3>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4">
                      <app-input
                        data-testid="global-do-not-rent-rental-error-message-input"
                        class="global-do-not-rent-rental-error-message-input"
                        :type="'text'"
                        :label="findSetting('globalSettings', 'global_do_not_rent_rental_error_message').label"
                        v-model="findSetting('globalSettings', 'global_do_not_rent_rental_error_message').value"
                        :error-messages="findError('global_do_not_rent_rental_error_message')"
                        :error="!!findError('global_do_not_rent_rental_error_message')"
                      />
                    </v-col>
                    <v-col cols="4">
                      <app-input
                        data-testid="global-do-not-rent-reservation-error-message-input"
                        class="global-do-not-rent-reservation-error-message-input"
                        :type="'text'"
                        :label="findSetting('globalSettings', 'global_do_not_rent_reservation_error_message').label"
                        v-model="findSetting('globalSettings', 'global_do_not_rent_reservation_error_message').value"
                        :error-messages="findError('global_do_not_rent_reservation_error_message')"
                        :error="!!findError('global_do_not_rent_reservation_error_message')"
                      />
                    </v-col>
                  </v-row>

                <h3>Features</h3>

                <v-row>
                  <v-col cols="4">
                    <v-switch
                      data-testid="global-setting-rent-online-switch"
                      class="global-setting-rent-online-switch"
                      :label="globalRentOnlineEnabled
                        ? 'Rent Online Enabled' : 'Rent Online Disabled'"
                      v-model="globalRentOnlineEnabled"
                    />
                  </v-col>
                </v-row>

                <h3>Unit Type — Short Name Setting</h3>
                <v-row>
                  <v-col cols="4">
                    <app-input
                        rules="regex|required"
                        :useValidation="true"
                        data-testid="global-website-short-name-pattern"
                        class="global-website-short-name-pattern"
                        :type="'text'"
                        :label="findSetting('globalSettings', 'global_short_name_pattern').label"
                        v-model="findSetting('globalSettings', 'global_short_name_pattern').value"
                        hint="Use valid Regular Expressions without delimiters. First matched parenthesis will be used as the abbreviated name"
                      />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="has-image" v-if="promoImage.value && JSON.parse(promoImage.value).url">
                    <h3 class="mb-2">Global Facility Promo Image</h3>
                    <v-img
                      :src="imageBasePath + JSON.parse(promoImage.value).url"
                      aspect-ratio="1"
                    >
                      <v-row
                        class="fill-height ma-0"
                        slot="placeholder"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular indeterminate color="grey" />
                      </v-row>
                    </v-img>
                    <v-btn
                      data-testid="global-setting-delete-promo-img-btn"
                      class="global-setting-delete-promo-img-btn v-btn--block error my-3 v-btn--small"
                      @click="openDelete(promoImage)"
                    >
                      Delete
                    </v-btn>
                  </v-col>
                  <v-col v-else class="no-image">
                    <h3>Global Facility Promo Image</h3>
                    <add-photo
                      data-testid="global-setting-add-promo-img-btn"
                      class="global-setting-add-promo-img-btn"
                      dispatchMethod="uploadGlobalSettingImage"
                      :additionalData="{ident: promoImage.ident}"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    class="has-image"
                    v-if="ogImage.value && JSON.parse(ogImage.value).url"
                  >
                    <h3 class="mb-2">Global Open Graph Image</h3>
                    <v-img
                      :src="imageBasePath + JSON.parse(ogImage.value).url"
                      aspect-ratio="1"
                    >
                      <v-row
                        class="fill-height ma-0"
                        slot="placeholder"
                        align="center"
                        justify="center"
                      >
                          <v-progress-circular indeterminate color="grey" />
                      </v-row>
                    </v-img>
                    <v-btn
                      data-testid="global-setting-delete-og-img-btn"
                      class="global-setting-delete-og-img-btn my-3 "
                      @click="openDelete(ogImage)"
                      color="error"
                      small
                      block
                    >
                        Delete
                    </v-btn>
                  </v-col>
                  <v-col v-else class="no-image">
                    <h3>Global Open Graph Image</h3>
                    <add-photo
                      data-testid="global-setting-add-og-img-btn"
                      class="global-setting-add-og-img-btn"
                      dispatchMethod="uploadGlobalOgImage"
                      :additionalData="{ident: ogImage.ident}"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <h3 class="mb-2">Global BBB Seal</h3>
                    <v-textarea
                      data-testid="global-setting-global-bbb-textarea"
                      class="global-setting-global-bbb-textarea"
                      label="Content"
                      filled
                      v-model="findSetting('largeGlobalSettings', 'global_bbb_seal').value"
                      :error-messages="findError('global_bbb_seal')"
                      :error="!!findError('global_bbb_seal')"
                      clearable
                    />
                  </v-col>
                </v-row>
              </div>
            </v-tab-item>

            <v-tab-item :style="$vuetify.theme.dark ? darkThemeBgColor : ''">
              <h2 class="mt-4 mb-2">Custom Code</h2>
              <div v-if="largeGlobalSettings.length">
                <v-textarea
                  data-testid="global-setting-markup-head-textarea"
                  class="global-setting-markup-head-textarea"
                  filled
                  :label="findSetting('largeGlobalSettings', 'global_markup_head').label"
                  v-model="findSetting('largeGlobalSettings', 'global_markup_head').value"
                  :error-messages="findError('global_markup_head')"
                  :error="!!findError('global_markup_head')"
                  clearable
                />
                <v-textarea
                  data-testid="global-setting-markup-body-textarea"
                  class="global-setting-markup-body-textarea"
                  filled
                  :label="findSetting('largeGlobalSettings', 'global_markup_body').label"
                  v-model="findSetting('largeGlobalSettings', 'global_markup_body').value"
                  :error-messages="findError('global_markup_body')"
                  :error="!!findError('global_markup_body')"
                  clearable
                />
                <v-textarea
                  data-testid="global-setting-css-textarea"
                  class="global-setting-css-textarea"
                  filled
                  :label="findSetting('largeGlobalSettings', 'global_custom_css').label"
                  v-model="findSetting('largeGlobalSettings', 'global_custom_css').value"
                  :error-messages="findError('global_custom_css')"
                  :error="!!findError('global_custom_css')"
                  clearable
                />
                <v-textarea
                  data-testid="global-setting-markup-livechat-textarea"
                  class="global-setting-markup-livechat-textarea"
                  filled
                  :label="findSetting('largeGlobalSettings', 'global_markup_livechat').label"
                  v-model="findSetting('largeGlobalSettings', 'global_markup_livechat').value"
                  :error-messages="findError('global_markup_livechat')"
                  :error="!!findError('global_markup_livechat')"
                  clearable
                />
              </div>
            </v-tab-item>
          </v-tabs>

          <div>
            <v-btn
              data-testid="global-setting-save-btn"
              class="global-setting-save-btn ml-0 mb-12"
              type="submit"
              color="primary"
              :loading="loading"
            >
              Save
            </v-btn>
          </div>
        </v-form>
      </v-container>
    </v-main>

    <delete-modal
      v-model="modal"
      @delete="deletePhoto"
      :itemType="'photo'"
      :advisory="'Warning: this action cannot be undone'"
    />
  </application-layout>
</template>

<script>
import AddPhoto from "@/components/AddPhoto.vue";
import ApplicationLayout from "@/layouts/ApplicationLayout.vue";
import DeleteModal from "@/components/DeleteModal.vue";

export default {
  components: {
    ApplicationLayout,
    AddPhoto,
    DeleteModal
  },
  data() {
    return {
      imageBasePath: process.env.VUE_APP_PHOTO_BASE_PATH + "/",
      loading: true,
      modal: false,
      selectedSetting: ""
    };
  },
  methods: {
    submitGlobalSettingsForm() {
      this.loading = true;
      this.$store.dispatch("updateGlobalSettings")
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.scrollUpIfValidationErrors();
        });
    },
    openDelete(setting) {
      this.selectedSetting = setting;
      this.modal = true;
    },
    findSetting(settings, ident) {
      return this[settings].find(setting => setting.ident === ident);
    },
    findError(ident) {
      if (!this.validationErrors || !this.validationErrors[ident]) {
        return null;
      }
      const error = this.validationErrors[ident];
      if (error[0] && error[0].match(/is required\.?$/i)) {
        return "This field is required";
      }
      return error;
    },
    scrollUpIfValidationErrors() {
      if (!this.validationErrors) {
        return;
      }
      const keys = Object.keys(this.validationErrors);
      if (!keys.length) {
        return;
      }
      this.$refs.globalSettingsForm.$el.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "start"
      });
    },
    deletePhoto() {
      this.loading = true;
      this.$store.dispatch("deleteGlobalSettingImage", {
        imageId: JSON.parse(this.selectedSetting.value).id,
        ident: this.selectedSetting.ident
      })
        .then(() => {
          this.$store.dispatch("getAllGlobalSettings");
          this.loading = false;
          this.selectedSetting = false;
          this.modal = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  },

  computed: {
    globalRentOnlineEnabled: {
      get() {
        const setting = this.findSetting(
          "globalSettings",
          "global_rent_online_enabled"
        );
        if (!setting) {
          return false;
        }
        const value = setting.value;
        if (!value) {
          return false;
        }
        if (
          value === "0" ||
          value === "false"
        ) {
          return false;
        }
        return !!value;
      },
      set(value) {
        this.findSetting(
          "globalSettings",
          "global_rent_online_enabled"
        ).value = value;
      }
    },
    darkThemeBgColor() {
      return this.$store.state.app.darkThemeBgColor;
    },
    validationErrors() {
      return this.$store.state.globalSetting.validationErrors;
    },
    globalSettings: {
      get() {
        return this.$store.state.globalSetting.globalSettings;
      },
      set(newValue) {
        this.$store.commit("setGlobalSettingsData", newValue);
      }
    },
    largeGlobalSettings: {
      get() {
        return this.$store.state.globalSetting.largeGlobalSettings;
      },
      set(newValue) {
        this.$store.commit("setLargeGlobalSettingsData", newValue);
      }
    },
    promoImage() {
      return this.findSetting("largeGlobalSettings", "global_facility_promo_image");
    },
    ogImage() {
      return this.findSetting("largeGlobalSettings", "global_og_image");
    }
  },
  created() {
    this.$store.dispatch("getAllGlobalSettings")
      .then(() => {
        this.loading = false;
      });
  }
};
</script>

<style lang="scss" scoped>
  .has-image {
    max-width: 300px;
  }
  .no-image {
    max-width: 300px;
    min-height: 200px;
  }
</style>
